import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

import { immigrationCleanByRules } from '@/store/party/partials/party-edit/helpers/pe-immigration-status-card'

export const PEImmigrationStatusCardActions = {
  initPeImmigrationStatusCard: ({ commit }, index) => {
    commit('setPeImmigrationStatusCardLock', { index, lock: true })
  },
  peImmigrationStatusCardCreate: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty

    const cleanSection = immigrationCleanByRules(section)

    return axiosRequest.
      post('/party_characteristics', {
        immigration_statuses: {
          party_id: party.id,
          immigration_status: cleanSection.immigration_status,
          admission_category: cleanSection.admission_category,
          niv_type: cleanSection.niv_type,
          certificate_number: cleanSection.certificate_number,
          naturalization_certificate_number: cleanSection.naturalization_certificate_number,
          i_94: cleanSection.i_94,
          immigration_status_other: cleanSection.immigration_status_other,
          date_expires: cleanSection.date_expires,
          date_expires_format: cleanSection.date_expires_format,
          date_expires_uncertain: cleanSection.date_expires_uncertain,
          date_obtained: cleanSection.date_obtained,
          date_obtained_format: cleanSection.date_obtained_format,
          date_obtained_uncertain: cleanSection.date_obtained_uncertain,
          place_obtained: cleanSection.place_obtained,
          notes: cleanSection.notes,
          current: cleanSection.current,
        },
      }).
      then(({ data }) => {
        commit('setPeImmigrationStatusCardLock', { index: 'new', lock: true })
        commit('setPeImmigrationStatusCardLock', { index: data.id, lock: true })
        commit('pePatchCharacteristicNew', {
          characteristic: 'immigration_statuses',
          value: data,
        })

        return data
      }).
      catch(handleError)
  },
  peImmigrationStatusCardRefresh: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty
    return axiosRequest.
      get(`/parties/${party.id}/party_characteristics/immigration_statuses/${section.id}`).
      then(({ data }) => {
        commit('setPeImmigrationStatusCardLock', { index, lock: true })
        commit('pePatchCharacteristic', {
          characteristic: 'immigration_statuses',
          value: data,
        })

        return data
      }).
      catch(handleError)
  },
  peImmigrationStatusCardUpdate: async ({ commit, getters }, { id, section, index }) => {
    const party = getters.peParty

    const cleanSection = immigrationCleanByRules(section)

    return axiosRequest.
      patch(`/party_characteristics/${id}`, {
        immigration_statuses: {
          party_id: party.id,
          immigration_status: cleanSection.immigration_status,
          admission_category: cleanSection.admission_category,
          niv_type: cleanSection.niv_type,
          certificate_number: cleanSection.certificate_number,
          naturalization_certificate_number: cleanSection.naturalization_certificate_number,
          i_94: cleanSection.i_94,
          immigration_status_other: cleanSection.immigration_status_other,
          date_expires: cleanSection.date_expires,
          date_expires_format: cleanSection.date_expires_format,
          date_expires_uncertain: cleanSection.date_expires_uncertain,
          date_obtained: cleanSection.date_obtained,
          date_obtained_format: cleanSection.date_obtained_format,
          date_obtained_uncertain: cleanSection.date_obtained_uncertain,
          place_obtained: cleanSection.place_obtained,
          notes: cleanSection.notes,
          current: cleanSection.current,
        },
        id,
      }).
      then(({ data }) => {
        commit('setPeImmigrationStatusCardLock', { index, lock: true })
        commit('pePatchCharacteristic', {
          characteristic: 'immigration_statuses',
          value: data,
        })

        return data
      }).
      catch(handleError)
  },
  peImmigrationStatusCardDelete: async ({ commit, getters }, { id, index }) => {
    const party = getters.peParty

    return axiosRequest.
      delete(`/party_characteristics/${id}`, {
        data: {
          immigration_statuses: {
            party_id: party.id,
          },
          id,
        },
      }).
      then(({ data }) => {
        const immigrationStatuses = data.immigration_statuses || []

        commit('setPeImmigrationStatusCardLock', { index, lock: true })
        commit('pePatchParty', {
          immigration_statuses: immigrationStatuses,
        })
      }).
      catch(handleError)
  },
  peImmigrationStatusCardAddSection: ({ commit }) => {
    commit('setPeImmigrationStatusCardLock', { index: 'new', lock: false })
    commit('addPeImmigrationStatusCardSection', {
      id: null,
      immigration_status: null,
      admission_category: null,
      niv_type: null,
      certificate_number: null,
      naturalization_certificate_number: null,
      i_94: null,
      immigration_status_other: null,
      date_expires: null,
      date_expires_format: null,
      date_expires_uncertain: null,
      date_obtained: null,
      date_obtained_format: null,
      date_obtained_uncertain: null,
      place_obtained: null,
      notes: null,
      current: true,
    })
  },
}

export const PEImmigrationStatusCardMutations = {
  setPeImmigrationStatusCardLock: (state, { index, lock }) => {
    if (!state.partyEdit.partySections.ImmigrationStatusCard) {
      Vue.set(state.partyEdit.partySections, 'ImmigrationStatusCard', {})
    }
    Vue.set(state.partyEdit.partySections.ImmigrationStatusCard, index, lock)
  },
  addPeImmigrationStatusCardSection: (state, section) => {
    state.partyEdit.party.immigration_statuses.push(section)
  },
  peImmigrationStatusCardCreateUndo: state => {
    const list = state.partyEdit.party.immigration_statuses
    const index = list.findIndex(status => status.id === null && status.current)
    if (index !== -1) list.splice(index, 1)

    Vue.set(state.partyEdit.partySections.ImmigrationStatusCard, 'new', true)
  },
}

export const PEImmigrationStatusCardGetters = {
  peImmigrationStatusCardLock: state => index => state.partyEdit.partySections.ImmigrationStatusCard[index],
  peImmigrationStatusCardHasNewSection: (_, getters) => !!getters.
    peParty.
    immigration_statuses?.
    find(immigrationStatus => immigrationStatus.id === null && immigrationStatus.current),
}
